var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 14,
  width: 21,
  height: 13.5,
  rx: 2,
  fill: "#23967f"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 14.8,
  y: 14,
  width: 3.2,
  height: 13.5,
  fill: "#f2c14e"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.6,
  cy: 13,
  rx: 2.3,
  ry: 1.15,
  fill: "#f2c14e",
  transform: "rotate(-24 13.6 13)"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.2,
  cy: 13,
  rx: 2.3,
  ry: 1.15,
  fill: "#f2c14e",
  transform: "rotate(24 19.2 13)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.4,
  cy: 13.4,
  r: 1,
  fill: "#d99a3f"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(7 30.5 28)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 24.5,
  width: 15,
  height: 7,
  rx: 1.2,
  fill: "#d99a3f"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-8 31 30.7)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 23.5,
  y: 27.2,
  width: 15,
  height: 7,
  rx: 1.2,
  fill: "#e0704f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m34.3 28v5.4",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 0.9,
  strokeDasharray: "1.3 1.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.3 28.4 0.75 1.45 1.45 0.75-1.45 0.75-0.75 1.45-0.75-1.45-1.45-0.75 1.45-0.75z",
  fill: "#ffffff"
}));

function SvgGiftCardRaffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardRaffle);
export default __webpack_public_path__ + "static/media/gift-card-raffle.a31eba1de449d761dc21509e269b4f2e.svg";
export { ForwardRef as ReactComponent };